export default __webpack_public_path__ + "static/media/ProgressStage6.dd3dd46d.svg";